import { useTranslation } from 'react-i18next';

import type { GameAudience } from '../../../stores/game/types';

import styles from './AudienceBadge.module.scss';
import { audienceBadgeText } from './audienceBadgeText';

interface AudienceBadgeProps {
  audiences?: GameAudience[];
}

/** Tells a tester which groups an "only for" game is limited to. Set by player-backend for testers only. */
export const AudienceBadge = ({ audiences }: AudienceBadgeProps) => {
  const { t } = useTranslation();
  const text = audiences && audienceBadgeText(audiences, t);

  if (!text) return null;

  return (
    <span className={styles.audienceBadge} data-testid="audience-badge">
      {text}
    </span>
  );
};
